import { ISubunit } from '@pia/pia.shared';
import { Injectable } from '@angular/core';
import { assignIn } from 'lodash';
import { SubunitViewModel } from 'src/app/business/institution/view-model/subunit-view-model';
import { SubunitDB } from 'src/app/common/repository/databases';
import { QueryService } from 'src/app/shared/services/query/query.service';

@Injectable({
  providedIn: 'root',
})
export class SubunitService {
  constructor(private _queryService: QueryService) {}

  public async loadSubunits(intitutionId: string): Promise<SubunitViewModel[]> {
    if (!intitutionId) {
      return;
    }
    const iSubunits =
      (await this._queryService.search<ISubunit>({ query: `institutionId:${intitutionId}` }, SubunitDB)) || [];

    const subunits = iSubunits
      .map(subunit => {
        const subunitViewModel = new SubunitViewModel();
        assignIn(subunitViewModel, subunit);
        return subunitViewModel;
      })
      .sort((subunitA, subunitB) => subunitA.name.localeCompare(subunitB.name, 'de', { sensitivity: 'base' }));

    return subunits;
  }

  public async loadSubunit(subunitId: string): Promise<SubunitViewModel> {
    if (!subunitId) {
      return;
    }
    const subunit = await this._queryService.get<ISubunit>(subunitId, SubunitDB);

    if (!subunit) {
      return;
    }
    const subunitViewModel = new SubunitViewModel();
    assignIn(subunitViewModel, subunit);
    return subunitViewModel;
  }

  public async getSubunitNamesForContact(institutionId: string, institutionContactId: string): Promise<string[]> {
    if (!institutionId || !institutionContactId) {
      return [];
    }
    const institutionSubunits =
      (await this._queryService.search<ISubunit>({ query: `institutionId:${institutionId}` }, SubunitDB)) || [];

    if (!institutionSubunits) {
      return [];
    }
    const institutionsForContact = institutionSubunits
      .filter(subunit => subunit.contactIds && subunit.contactIds.includes(institutionContactId))
      .map(subUnit => subUnit.name);

    return institutionsForContact;
  }
}
